// Global stores registered on init
document.addEventListener('alpine:init', () => {
  Alpine.store('theme', {
    current: 'light',

    setBG(color) {
      this.current = color;
      console.log(this.current);
    }
  });

  Alpine.store('menu', {
    isOpen: false,
    
    toggle() {
      this.isOpen = !this.isOpen;
      
      // Toggle body overflow class
      if (this.isOpen) {
        document.body.classList.add('nav-open');
      } else {
        document.body.classList.remove('nav-open');
      }
    }
  });
});
